import { render, staticRenderFns } from "./Pannars.vue?vue&type=template&id=2155bede&scoped=true&"
import script from "./Pannars.vue?vue&type=script&lang=js&"
export * from "./Pannars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155bede",
  null
  
)

export default component.exports